import moment from "moment";
export default class DateUtils {
    static shortDate(date, locale = "en-US") {
        const options = {
            year: "2-digit",
            month: "numeric",
            day: "numeric",
        };
        return date && new Intl.DateTimeFormat(locale, options).format(date);
    }
    static dateTime(date, locale = "en-US") {
        const options = {
            year: "2-digit",
            month: "numeric",
            day: "2-digit",
            weekday: "short",
            hour: "numeric",
            minute: "2-digit",
        };
        return date && new Intl.DateTimeFormat(locale, options).format(date);
    }
    static makeRelative(date) {
        const relativeString = moment(date).from(moment(new Date()), true) + " ago";
        // let relativeString =  $rootScope.timeDuration(date, new Date().toISOString())+ ' ago';
        return relativeString.charAt(0).toUpperCase() + relativeString.substr(1);
    }
    static getMonthDisplay3Letter(monthNumber) {
        return DateUtils.getMonthName(monthNumber).substr(0, 3);
    }
    static getMonthName(monthNumber) {
        let monthName = "";
        if (monthNumber === 1) {
            monthName = "January";
        }
        else if (monthNumber === 2) {
            monthName = "February";
        }
        else if (monthNumber === 3) {
            monthName = "March";
        }
        else if (monthNumber === 4) {
            monthName = "April";
        }
        else if (monthNumber === 5) {
            monthName = "May";
        }
        else if (monthNumber === 6) {
            monthName = "June";
        }
        else if (monthNumber === 7) {
            monthName = "July";
        }
        else if (monthNumber === 8) {
            monthName = "August";
        }
        else if (monthNumber === 9) {
            monthName = "September";
        }
        else if (monthNumber === 10) {
            monthName = "October";
        }
        else if (monthNumber === 11) {
            monthName = "November";
        }
        else if (monthNumber === 12) {
            monthName = "December";
        }
        return monthName;
    }
    static getDayOfWeekName(dayOfWeekNumber) {
        let dayOfWeekName = "";
        if (dayOfWeekNumber === 1) {
            dayOfWeekName = "Monday";
        }
        else if (dayOfWeekNumber === 2) {
            dayOfWeekName = "Tuesday";
        }
        else if (dayOfWeekNumber === 3) {
            dayOfWeekName = "Wednesday";
        }
        else if (dayOfWeekNumber === 4) {
            dayOfWeekName = "Thursday";
        }
        else if (dayOfWeekNumber === 5) {
            dayOfWeekName = "Friday";
        }
        else if (dayOfWeekNumber === 6) {
            dayOfWeekName = "Saturday";
        }
        else if (dayOfWeekNumber === 7) {
            dayOfWeekName = "Sunday";
        }
        return dayOfWeekName;
    }
    static getYearMonthDisplay(yearMonth) {
        const year = parseInt(yearMonth.substr(0, 4), 10);
        const month = parseInt(yearMonth.substr(4, 2), 10);
        return `${DateUtils.getMonthDisplay3Letter(month)} ${year}`;
    }
    static getYearQuarterDisplay(yearQuarter) {
        const year = parseInt(yearQuarter.substr(0, 4), 10);
        const quarter = parseInt(yearQuarter.substr(4, 2), 10);
        return `${year} Q${quarter}`;
    }
}
